// extracted by mini-css-extract-plugin
export default {"signUpFormContainer":"SignUpForm_signUpFormContainer__sZKM0","heading":"SignUpForm_heading__qTq2X","headingDescription":"SignUpForm_headingDescription__w83DO"};